// extracted by mini-css-extract-plugin
module.exports = {"formatTitle":"PhotoHelp_formatTitle__VABuK"};